var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgMyLocation = function SvgMyLocation(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m3 11h2.5v2h-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.5 11h2.5v2h-2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 21v-2.5h2v2.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11 5.5v-2.5h2v2.5z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 6,
    stroke: "currentColor",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    fill: "currentColor",
    r: 3
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMyLocation);
export default ForwardRef;